<mat-checkbox
  [checked]="isChecked"
  [disabled]="isDisabled"
  (change)="onCheckboxChecked($event)"
>
  <ng-content></ng-content>
</mat-checkbox>
